import { Flex, Spin } from 'antd';
import { useRef } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { useIframePageEffects, useIframePage } from '@pages/IframePage/hooks';
import type { IframePageProps } from '@pages/IframePage/types';

import type { FC } from 'react';

import '@pages/IframePage/styles/IframePage.desktop.scss';

const PF = 'iframe-page';

export const IframePage: FC<IframePageProps> = (props) => {
  const { initialMessage, isEmbedded, title, withContextInUrl = true } = props;
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const redirectTo = searchParams.get('redirectTo');

  const savedRedirectToRef = useRef<string | null>(null);

  const finalRedirectTo = redirectTo || savedRedirectToRef.current;

  const redirectUrl = finalRedirectTo
    ? decodeURIComponent(finalRedirectTo)
    : `${location.pathname}${location.search}`;

  const iframeRef = useRef<HTMLIFrameElement>(null);

  const {
    handleChildNavigation,
    accessToken,
    setIsLoading,
    isLoading,
    hostOrigin,
    iframeUrl,
  } = useIframePage(props, iframeRef);

  useIframePageEffects({
    handleChildNavigation,
    iframeRef,
    hostOrigin,
    isIframeLoaded: !isLoading,
    isEmbedded,
  });

  const handleIframeLoad = () => {
    setIsLoading(false);

    const message = initialMessage?.({ accessToken });
    const win = iframeRef.current?.contentWindow;

    if (!message || !win) return;

    win.postMessage(message, hostOrigin);
  };

  return (
    <Flex flex={1} className={`${PF}_container`}>
      {isLoading && <Spin spinning size="large" className={`${PF}_loader`} />}
      <iframe
        ref={iframeRef}
        src={iframeUrl}
        title={title}
        data-jwt={accessToken || undefined}
        data-redirect={withContextInUrl ? redirectUrl : undefined}
        width="100%"
        height="100%"
        allow="clipboard-write"
        frameBorder="0"
        onLoad={handleIframeLoad}
      />
    </Flex>
  );
};
